import watchGetConnections from './getConnections';
import watchGetAccounts from './getAccounts';

const watchConnections = [watchGetConnections, watchGetAccounts];

export default watchConnections;
